export default function analyticsWidgetsUsing(widget = null) {
	if (widget == null) {
		// Get elements
		if (localStorage.getItem('use_widgets') == null) {
			return [];
		} else {
			return localStorage.getItem('use_widgets').split(',');	
		}
	} else {
		// Add some element to widgets
		if (localStorage.getItem('use_widgets') == null) {
			localStorage.setItem('use_widgets',widget);
			return [widget];
		} else {
			const arrayOfWidgets = localStorage.getItem('use_widgets').split(',');
			if (arrayOfWidgets.indexOf(widget) === -1) {
				arrayOfWidgets.push(widget);
			}
			localStorage.setItem('use_widgets',arrayOfWidgets.join(','));
			return arrayOfWidgets;
		}
	}
}